import React, { useRef, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export function VipClubForm() {
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  const startedAt = useRef(Date.now());

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setState("sending"); setErr("");
    try {
      const r = await fetch(`${API}/api/public/vip-club/signup`, { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, website: hp, started_at: startedAt.current, page_path: window.location.pathname }) });
      if (r.ok) { setState("done"); return; }
      const d = await r.json().catch(() => ({}));
      setErr(typeof d.detail === "string" ? d.detail : "That didn’t go through — double-check the email and try again.");
      setState("idle");
    } catch { setErr("That didn’t go through — please try again."); setState("idle"); }
  };

  return (
    <div className="vip" data-testid="vip-club">
      <div>
        <p className="vip-title">Join Our <span>VIP Club</span></p>
        <p className="vip-caption">Stay current with the latest topics, mortgage news and get in on our exciting monthly giveaways exclusive to our members. It’s about quality over quantity — (<em>no spam here — we don’t like it either!</em>). Unsubscribe anytime.</p>
      </div>
      {state === "done" ? (
        <div className="vip-done" role="status" data-testid="vip-success"><strong>Welcome To The Club!</strong><p>Check your inbox — your first note from us is on its way.</p></div>
      ) : (
        <form className="vip-form" onSubmit={submit} data-testid="vip-form">
          <label className="vip-hp" aria-hidden="true">Website<input type="text" tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} data-testid="vip-honeypot" /></label>
          <div className="vip-row">
            <input type="email" required placeholder="Enter your email address" aria-label="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="vip-email" />
            <button type="submit" className="btn" disabled={state === "sending"} data-testid="vip-submit">{state === "sending" ? "Joining…" : "Join The Club"}</button>
          </div>
          {err && <p className="vip-err" role="alert" data-testid="vip-error">{err}</p>}
        </form>
      )}
    </div>
  );
}
